// extracted by mini-css-extract-plugin
export default {"input":"Search_input__g9HGr","btn":"Search_btn__kMIma"};